import { useMutation, useQuery, useQueryClient } from 'react-query';
import { getUnassignedTissues } from '@/services/common';
import { createReturnOrder, getReturnOrderById } from '@/services/orderReturns';
import type { CreateReturnOrderPayload } from '@/types/orderReturns';

export const useCreateReturnOrder = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (payload: CreateReturnOrderPayload) => createReturnOrder(payload),
    onSuccess: () => {
      queryClient.invalidateQueries(['returns']);
      if (onSuccess) onSuccess();
    },
  });
};

export const useGetUnassignedTissues = (clinicName: string, enabled: boolean) => {
  return useQuery({
    queryKey: ['unassigned-tissues', clinicName],
    queryFn: () => getUnassignedTissues(clinicName),
    enabled: enabled && !!clinicName,
    keepPreviousData: false,
  });
};

export const useGetReturnOrderById = (id: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['return-order', id],
    queryFn: () => getReturnOrderById(id),
    enabled: enabled && !!id,
  });
};

